import { genComponentEl } from '@/utils/utils';
import Component from './index.vue';

/**
 * 显示设备预案
 * @param {Object} data
 */
export function showSendDataIntervalSetting(data) {
  genComponentEl(Component, data);
}
